export default "__VITE_PUBLIC_ASSET__04e397b1__"